import React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { connect } from "react-redux";
import * as Stories from "src/redux/stories";
import LoginPage from "src/components/Login";
import { Redirect } from "react-router-dom";
import { setLogin } from "src/api/projects";
import * as Logged from "src/redux/logged";
import { toast } from "react-toastify";

function mapDispatchToProps(dispatch) {
  return {
    init: () => dispatch(Stories.init()),
    setLogged: (logged: boolean) => dispatch(Logged.setLogged(logged))
  };
}
// Props are coming from react router
// type RouterProps = RouteComponentProps<{ appKey?: string }>;
type Props = ReturnType<typeof mapDispatchToProps> & WithNamespaces;
/**
 * Main container of our app, handle common logic:
 * showing available apps etc...
 */
interface State {
  redirect: boolean;
}
class LoginContainerToConnect extends React.Component<Props, State> {
  state = {
    redirect: false
  };
  connect = async (login, pwd) => {
    this.props.setLogged(false);
    const userLogin = await setLogin(login, pwd);
    if (!userLogin.token) {
      return toast.error(this.props.t("error.login"));
    }
    return this.setState({
      redirect: true
    });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to="/projects" />;
    }
    return <LoginPage connect={this.connect} />;
  }
}

export const LoginContainer = withNamespaces()(
  connect(
    null,
    mapDispatchToProps
  )(LoginContainerToConnect)
);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.tsx